import { BarcodeDTO } from './BarcodesDTO'
import { Barcode } from './BarcodesModel'

export const mapBarcodeDTOtoBarcode = (barcodeDTO: BarcodeDTO): Barcode => {
    return barcodeDTO as Barcode
}
